import React from 'react';
import {
    Switch,
    Route,
    useRouteMatch,
    Redirect,
    useLocation,
    NavLink
} from 'react-router-dom';
import TabPanel from '../../components/TabPanel';
import AppSidebar from '../../components/Sidebar/AppSidebar';
import {
    CapTableIcon,
    HoldersIcon,
    FundraiseIcon,
    TransfersIcon,
} from '../../components/Sidebar/sidebarIcons';
import { connect } from 'react-redux';
import { isFeatureLocked } from '../../utilities/utils';
import { isTALoggedAsIssuer } from '../../utilities/utils';
import InvestorRoutes from './InvestorRoutes';
import TransferRoutes from './TransferRoutes';
import FundraiseRoutes from './FundraiseRoutes';
import CapTableRoutes from './CapTableRoutes';

import TAPartners from '../../pages/issuer/Transfer/TAPartners';
import KycPage from '../../pages/issuer/Investors/KycPage';
import Container from '@mui/material/Container';
import Communications from '../../pages/issuer/Investors/Communications';
import UploadDocuments from '../../pages/issuer/Dashboard/UploadDocuments';
import CapTableList from '../../pages/issuer/Dashboard/CapTableList';
import BlockchainScreen from '../../pages/issuer/Blockchain/BlockchainScreen';
import EditInvestorInfo from '../../pages/issuer/Investors/EditInvestorInfo';
import ManageClassInfo from '../../pages/issuer/Dashboard/ManageClassInfo';
import SetupWizard from '../../pages/issuer/Dashboard/SetupWizard';
import { SUBSCRIPTION_BASIC, SUBSCRIPTION_PRO, SUBSCRIPTION_ENTERPRISE } from '../../constants/profile';
import PreferenceRoutesContainer from './PreferenceRoutesContainer';
import MuiAlert from '@mui/material/Alert';
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const IssueRoutesContainer = (props) => {
    let { path } = useRouteMatch();
    const location = useLocation();
    let current_screen = location.pathname.split('/');
    let isWizard = current_screen[current_screen.length - 1] === 'setup-wizard';
    path = path === '/issuer'  ? `${path}/issue` : path;

    const preferredTabs = (props.profile && props.profile.preferred_tabs) || {};
    const taLoggedAsIssuer = props.profile && isTALoggedAsIssuer(props.profile);
    const proLocked = isFeatureLocked(
        SUBSCRIPTION_PRO,
        props.profile && props.profile.subscription_model
            ? props.profile.subscription_model
            : SUBSCRIPTION_BASIC
    );

    const sidebarGroups = [
        {
            key: 'cap-table',
            label: 'Cap Table',
            icon: <CapTableIcon />,
            children: [
                { label: 'Overview', path: `${path}/cap-table`, exact: true, display: preferredTabs.captable },
                { label: 'Manage Classes', path: `${path}/cap-table/class-info`, display: preferredTabs.classes },
                { label: 'Manage Holders', path: `${path}/cap-table/holder-info`, display: preferredTabs.holders },
                { label: 'Documents', path: `${path}/cap-table/documents`, disabled: proLocked },
                { label: 'Blockchain', path: `${path}/cap-table/blockchain`, display: preferredTabs.blockchain, disabled: proLocked },
            ],
        },
        {
            key: 'holders',
            label: 'Holders',
            icon: <HoldersIcon />,
            children: [
                { label: 'Overview', path: `${path}/holders`, exact: true },
                { label: 'Events', path: `${path}/holders/events` },
                { label: 'KYC', path: `${path}/holders/kyc` },
                { label: 'Documents', path: `${path}/holders/documents` },
                { label: 'Distributions', path: `${path}/holders/distributions` },
                { label: 'Invite', path: `${path}/holders/invite` },
            ],
        },
        {
            key: 'fundraise',
            label: 'Fundraise',
            icon: <FundraiseIcon />,
            children: [
                { label: 'Overview', path: `${path}/fundraise`, exact: true },
                { label: 'Data Room', path: `${path}/fundraise/data-room` },
                { label: 'Templates', path: `${path}/fundraise/templates` },
                { label: 'Registered Interests', path: `${path}/fundraise/registered-interests` },
            ],
        },
        {
            key: 'transfers',
            label: 'Transfers',
            icon: <TransfersIcon />,
            display: preferredTabs.transfers,
            children: [
                { label: 'Overview', path: `${path}/transfers`, exact: true },
                { label: 'Transfer', path: `${path}/transfers/transfer` },
                { label: 'Retirement', path: `${path}/transfers/retirement` },
                { label: 'Approvals', path: `${path}/transfers/approvals` },
                { label: 'History', path: `${path}/transfers/history` },
                { label: 'External', path: `${path}/transfers/external` },
                ...(taLoggedAsIssuer ? [] : [{ label: 'TA Partners', path: `${path}/transfers/transfer-agents` }]),
            ],
        },
    ];

    const alertBanner = !props.profile.has_cap_table &&
        props.profile.scope !== 'list' &&
        !isWizard && (
            <React.Fragment>
                <br />
                <Alert
                    severity="warning"
                    style={{
                        borderRadius: 15,
                        opacity: '80%',
                        fontSize: '1rem',
                    }}
                >
                    Cap Table has not been detected. You can upload it
                    from the{' '}
                    <b>
                        <NavLink
                            to={`${path}/cap-table/setup-wizard`}
                            style={{
                                textDecoration: 'underline',
                                fontSize: '1rem',
                                color: 'white',
                            }}
                        >
                            Setup Wizard tab.{' '}
                        </NavLink>
                    </b>
                </Alert>
                <br />
            </React.Fragment>
        );

    return (
      <Container maxWidth={false} disableGutters>
        <div className="idb-issue-shell">
          <AppSidebar
              sections={[
                  { key: 'issue', label: 'Issue', path: '/issuer/issue' },
                  { key: 'list', label: 'List', path: '/issuer/list' },
              ]}
              groups={sidebarGroups}
          />
          <div className="idb-issue-content">
            {alertBanner}
            <TabPanel >

            {props.profile && props.profile.subscription_model && props.profile.subscription_model === SUBSCRIPTION_ENTERPRISE ?
              (
                <Switch>
                  <Route exact path={`${path}/`}>
                      <Redirect to={`${path}/cap-table`} />
                  </Route>
                  <Route
                      path={`${path}/cap-table`}
                      component={CapTableRoutes}
                  />
                  <Route
                      path={`${path}/preferences`}
                      component={PreferenceRoutesContainer}
                  />
                  <Route
                      path={`${path}/holders`}
                      component={InvestorRoutes}
                  />
                  <Route
                      path={`${path}/fundraise`}
                      component={FundraiseRoutes}
                  />
                  <Route
                      path={`${path}/transfers`}
                      component={TransferRoutes}
                  />
                   <Route
                      path={'/issuer/preferences'}
                      component={PreferenceRoutesContainer}
                  />
                    <Route
                      path={`${path}/cap-table/setup-wizard`}
                      component={SetupWizard}
                  />
              </Switch>
              ) : (
                <Switch>
                  <Route exact path={`${path}/`}>
                      <Redirect to={`${path}/cap-table`} />
                  </Route>
                  <Route
                      path={`${path}/cap-table/class-info`}
                      component={ManageClassInfo}
                  />
                  <Route
                      path={`${path}/cap-table/holder-info`}
                      component={EditInvestorInfo}
                  />
                  <Route  path={`${path}/cap-table/kyc`} component={KycPage} />
                  <Route
                      path={`${path}/cap-table/documents`}
                      component={UploadDocuments}
                  />
                  <Route
                      exact
                      path={`${path}/cap-table/blockchain`}
                      component={BlockchainScreen}
                  />
                  <Route
                      path={`${path}/cap-table/transfer-agents`}
                      component={TAPartners}
                  />

                  {/*    <Route
                      exact
                      path={`${path}/scenarios`}
                      component={Scenarios}
                  />*/}
                  <Route
                      path={`${path}/cap-table/events`}
                      component={Communications}
                  />
                  <Route
                      path={`${path}/cap-table/setup-wizard`}
                      component={SetupWizard}
                  />

                  <Route
                      path={'/issuer/preferences'}
                      component={PreferenceRoutesContainer}
                  />
                  <Route
                      path={`${path}/holders`}
                      component={InvestorRoutes}
                  />
                  <Route
                      path={`${path}/fundraise`}
                      component={FundraiseRoutes}
                  />
                  <Route
                      path={`${path}/transfers`}
                      component={TransferRoutes}
                  />
                  <Route
                      path={`${path}/cap-table`}
                      component={CapTableList}
                  />
              </Switch>
              )
            }
            </TabPanel>
          </div>
        </div>
      </Container>
  );
};

const mapStateToProps = ({ profile }) => {
    return {
        preferredTabs: profile.preferred_tabs,
        profile: profile
    };
};

export default connect(mapStateToProps, null)(IssueRoutesContainer);
